import Component from 'gia/Component';
import Swiper from 'swiper';
import { gsap } from 'gsap';
import { Navigation, Pagination } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


export default class Timeline extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      swiper: {},
      slides: []
    };
  }

  mount() {
    let that = this;

    const swiper = new Swiper(this.ref.swiper, {
      // configure Swiper to use modules
      modules: [Navigation, Pagination],
      navigation: {
        nextEl: '.c--next',
        prevEl: '.c--prev',
      },
      speed: 1000,
      pagination: {
        el: '.swiper-pagination',

        type: 'bullets',
        clickable: true,
        renderBullet: function(bulletIndex, className) {

          let year = that.ref.slides[bulletIndex].dataset.year;

          let width = ' !w-[55px]';
          if (bulletIndex + 1 == that.ref.slides.length) {
            width = ' !w-[12px]';
          }

          let output = '<div class="' + className + width + ' flex">';

          output +=
            '<div class="relative h-[12px] flex items-center ">' +
            '<div class="h-[3px] bg-[#C0C0C1] w-full"></div>' +
            '<div class="swiper-pagination-bullet__circle  absolute bottom-0 w-[12px] h-[12px] rounded-full transform top-1/2 -translate-y-1/2">' +
            '<div class="text-[16px] font-medium text-blue -translate-x-[calc(50%-6px)] absolute left-0 -top-8">' + year + '</div>' +
            '</div>' +
            '</div>';
          output += '</div>';
          return output;
        },
        // renderCustom: function(swiper, current, total) {
        //   console.log(current);
        //   // let year = that.ref.slides[current].dataset.year;
        //   let output = '<div class="flex">';
        //   that.ref.slides.forEach(function(slide, index) {
        //     let year = slide.dataset.year;
        //     let className = '';
        //     if (index == current - 1) {
        //       className = 'bg-blue';
        //     } else {
        //       className = 'bg-[#C0C0C1]';
        //     }
        //     let width = 'w-[70px]';
        //     if (index + 1 == total) {
        //       width = 'w-[12px]';
        //     }
        //     output +=
        //       '<div class="' + width + ' relative h-[12px] flex items-center ">' +
        //       '<div class="h-[3px] bg-[#C0C0C1] w-full"></div>' +
        //       '<div class="' + className + ' absolute bottom-0 w-[12px] h-[12px] rounded-full transform top-1/2 -translate-y-1/2">' +
        //       '<div class="text-[20px] font-medium text-blue -translate-x-[calc(50%-6px)] absolute left-0 -top-8">' + year + '</div>' +
        //       '</div>' +
        //       '</div>';
        //   })
        //   output += '</div>';
        //   return output;
        //   // return '<span class="">' + year + '</span>';
        // },
      },
    });
    swiper.on('slideChange', function() {
      console.log('slide changed');
      let length = that.ref.slides.length;
      console.log(swiper.previousIndex);
      console.log(swiper.realIndex);
      if (swiper.realIndex == 0) {
        document.querySelector('.c--timeline .c--prev').classList.add('hidden');
      } else {
        document.querySelector('.c--timeline .c--prev').classList.remove('hidden');
        let prevYear = that.ref.slides[swiper.realIndex - 1].dataset.year;
        document.querySelector('.c--timeline .c--prev-text').innerHTML = prevYear;
      }

      if (swiper.realIndex == length - 1) {
        document.querySelector('.c--timeline .c--next').classList.add('hidden');
      } else {
        document.querySelector('.c--timeline .c--next').classList.remove('hidden');
        let nextYear = that.ref.slides[swiper.realIndex + 1].dataset.year;
        document.querySelector('.c--timeline .c--next-text').innerHTML = nextYear;
      }

      // document.querySelector('.c--timeline .c--next-text').innerHTML = nextYear;
      gsap.to(that.ref.slides[swiper.realIndex].querySelectorAll(".swiper-slide__animate"), {x: 0, duration: 1, stagger: 0.1});

      // move all next to 200

      // move all previous to -200
      if (swiper.realIndex != 0) {
        for (let i = 0; i < swiper.realIndex; i++) {
          gsap.to(that.ref.slides[i].querySelectorAll(".swiper-slide__animate"), {x: -100, duration: 1, stagger: 0.2});
        }
      }
      if (swiper.realIndex != length - 1) {
        for (let i = swiper.realIndex + 1; i < length; i++) {
          gsap.to(that.ref.slides[i].querySelectorAll(".swiper-slide__animate"), {x: 100, duration: 1, stagger: 0.2});
        }
      }
    });


  }


}